var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-burger",class:{ 'is-active': _vm.isActive },attrs:{"data-target":"navbarMenu"}},[_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }